// extracted by mini-css-extract-plugin
export default {"twoImage":"GiftAtNykaa_twoImage__11K-P","TIdiv":"GiftAtNykaa_TIdiv__Y3G9S"};